/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ConfigurazioneMailForm } from './configurazione-mail-form';


export interface ConfigurazioneMailValidateRequest { 
    configurazione?: ConfigurazioneMailForm;
}

